import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MiscellaneousFeesComplianceModel } from 'src/Models/OngoingComplianceModel';
import { PricingQuotesService } from 'src/Services/pricing-quotes.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-miscellaneousfees',
  templateUrl: './miscellaneousfees.component.html',
  styleUrls: ['./miscellaneousfees.component.css']
})
export class MiscellaneousfeesComponent implements OnInit {

  isUserSystemAdmin: boolean = true;
  tokenKey: string;
  listofMiscFees: MiscellaneousFeesComplianceModel[];
  listofMiscFeesExport: MiscellaneousFeesComplianceModel[];
  SelectedTool: string;

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  MiscFeesTitle: string;
  isloading: boolean = false;
  isRecord: boolean = false;
  totalRecordCount: number = 0;
  isAscending: boolean = false;
  upDowTitleCSS: string = '';
  upDowAmountCSS: string = '';
  upDowNotesCSS: string = '';
  upDowLastUpdatedDateCSS: string = '';
  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private priceQuoteService: PricingQuotesService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofMiscFees = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'MiscellaneousTitle';
    this.MiscFeesTitle = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Miscellaneous-Fees');
  }

  ngOnInit() {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    this.GetAllMiscellaneousFees();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  addMiscFees() {
    this.router.navigate(['admin/PricingQuote/Manage/Miscellaneousfees/']);
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetAllMiscellaneousFees();
  }

  keywordFilters($event) {
    this.PageNumber = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.MiscFeesTitle = $event.target.value;
    else
      this.MiscFeesTitle = 'null';

    this.GetAllMiscellaneousFees();
  }

  sort(sortBy: string) {
    this.upDowAmountCSS = '';
    this.upDowNotesCSS = '';
    this.upDowTitleCSS = '';
    this.upDowNotesCSS = '';
    this.upDowLastUpdatedDateCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';

      if (sortBy === "MiscellaneousTitle") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "MiscellaneousAmount") {
        this.upDowAmountCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "MiscellaneousNote") {
        this.upDowNotesCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "UpdatedDate") {
        this.upDowLastUpdatedDateCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "MiscellaneousTitle") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "MiscellaneousAmount") {
        this.upDowAmountCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "MiscellaneousNote") {
        this.upDowNotesCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "UpdatedDate") {
        this.upDowLastUpdatedDateCSS = 'fa fa-arrow-up';
      }
    }
    this.PageNumber = 1;
    this.GetAllMiscellaneousFees();
  }

  GetAllMiscellaneousFees() {
    this.isloading = true;
    this.listofMiscFees = [];
    if (this.MiscFeesTitle == "null") this.MiscFeesTitle = " ";
    this.priceQuoteService.GetAllMiscellaneousFees(this.tokenKey, this.PageNumber, this.PageSize, this.MiscFeesTitle, this.OrderBy, false).subscribe(
      data => {
        this.isloading = false;
        this.listofMiscFees = data['miscFeesData'];
        if (this.listofMiscFees != null) {
          if (this.listofMiscFees.length == 0)
            this.isRecord = true;
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofMiscFees[0].totalRecordCount;
          }
        }
        else
          this.isRecord = true;
      },
    );
  }

  updateMiscFees(miscId) {
    let navigation = 'admin/PricingQuote/Manage/Miscellaneousfees/' + miscId;
    this.router.navigate([navigation]);
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportMiscellaneousFeeMaster() {
    this.isloading = true;
    this.listofMiscFeesExport = [];
    if (this.MiscFeesTitle == "null") this.MiscFeesTitle = " ";
    this.priceQuoteService.GetAllMiscellaneousFees(this.tokenKey, this.PageNumber, this.PageSize, this.MiscFeesTitle, this.OrderBy, true).subscribe(
      data => {
        this.listofMiscFeesExport = data['miscFeesData'];
        if (this.listofMiscFeesExport != null) {
          if (this.listofMiscFeesExport.length > 0) {
            setTimeout(() => {
              this.DownloadMiscellaneousFeeMaster();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadMiscellaneousFeeMaster() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportPriceQuoteMiscellaneousFeeMaster';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportPriceQuoteMiscellaneousFeeMaster.xls");
  }
}
